module.exports = __webpack_public_path__ + "img/77320.4432946a.svg";